import React from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { injectIntl } from 'react-intl';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Alert from '@material-ui/lab/Alert';
import { buildLink, getLinkId } from 'Services/tools';

/**
 * Tournament picker for the award form.
 * - lists the tournaments of the current competition (when provided);
 * - when a tournament is picked, the award name + dates are pre-filled from it
 *   (the fields stay editable);
 * - if the tournament is not in the list, leave empty and fill name/dates manually.
 *
 * The relation is always stored as an IRI (reference): we never send a nested
 * Tournament object, so picking a tournament never writes into the Tournament entity.
 */
class TournamentField extends React.Component {
  handleChange = event => {
    const id = event.target.value;
    const { input, dispatch, tournaments = [], meta } = this.props;
    const form = meta.form;

    if (!id) {
      input.onChange(null);

      return;
    }

    input.onChange(buildLink('Tournament', id));

    // Pre-fill the award's own scalar fields from the chosen tournament (still editable).
    // The competition's tournament list already carries name/startDate/endDate, so no
    // extra fetch is needed.
    const tournament = tournaments.find(t => String(t.id) === String(id));
    if (!tournament) {
      return;
    }
    // tournamentName is a short season label (VARCHAR(9)), not the full tournament name
    // (e.g. "2026 Canada/Mexico/USA"). Fall back to the short season; the field stays editable.
    const seasonLabel = tournament.seasonName || tournament.seasonShortName || '';
    dispatch(change(form, 'tournamentName', seasonLabel));
    dispatch(change(form, 'tournamentStartDate', tournament.startDate || null));
    dispatch(change(form, 'tournamentEndDate', tournament.endDate || null));
  };

  render() {
    const {
      input,
      tournaments = [],
      intl: { messages: m },
    } = this.props;
    const selectedId = input.value ? getLinkId(input.value) : '';

    return (
      <React.Fragment>
        <Alert severity="warning" style={{ marginBottom: 12 }}>
          {m.tournamentAward_tournamentHint}
        </Alert>
        <FormControl fullWidth>
          <InputLabel shrink>{m.field_tournament}</InputLabel>
          <Select value={selectedId} onChange={this.handleChange} displayEmpty>
            <MenuItem value="">{m.tournamentAward_noTournament}</MenuItem>
            {tournaments.map(tournament => (
              <MenuItem key={tournament.id} value={String(tournament.id)}>
                {tournament.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </React.Fragment>
    );
  }
}

export default injectIntl(connect()(TournamentField));
